import "@/components/Charts/charts.scss";
import Charts from "./Charts";
import ReportChips from "kinnect-general/reports/ReportChips";
import ReportFilters from "kinnect-general/reports/ReportFilters";
import ReportHeader from "kinnect-general/reports/ReportHeader";
import { FetchesData, Reportable } from "kinnect-mixins";
import { KAutocomplete, KDatePicker } from "kinnect-general";
import { VCard, VCardText } from "vuetify/lib";
import { YardDeliveryNoteReport } from "kinnect-models";
import { sortByKey } from "kinnect-helpers";

export default {
	name: "DeliveryNotesReport",

	mixins: [
		FetchesData,
		Reportable
	],

	data: () => ( {
		reports: []
	} ),

	computed: {
		driver: {
			get() {
				return this.$route.query.driver ? parseInt( this.$route.query.driver ) : "all";
			},
			set( driver ) {
				const query = Object.assign( {}, this.$route.query, { driver } );

				if ( !driver || driver === "all" ) {
					delete query.driver;
				}

				this.$router.replace( { query } );
			}
		},

		selectedReport() {
			if ( this.driver && this.driver !== "all" ) {
				return this.reports.find( report => report.driver.id === this.driver );
			}
		},

		selectableDrivers() {
			const items = [
				{
					text: "All",
					value: "all"
				}
			];

			const reportItems = this.reports.map( report => ( {
				text: report.driver.user.name,
				value: report.driver.id
			} ) );
			const sortedReportItems = sortByKey( reportItems, "text" );

			items.push( ...sortedReportItems );

			return items;
		},

		selectedDriverName() {
			if ( this.driver === "all" ) {
				const item = this.selectableDrivers.find( driver => driver.value === "all" );

				return item.text;
			}

			if ( this.selectedReport ) {
				return this.selectedReport.driver.user.name;
			}

			return null;
		}
	},

	methods: {
		saveReportFilters( props ) {
			const initialStartDate = this.startDate;
			const initialEndDate = this.endDate;

			this.driver = props.driver;
			this.startDate = props.startDate;
			this.endDate = props.endDate;

			if ( this.startDate !== initialStartDate
				|| this.endDate !== initialEndDate
			) {
				this.fetchReport();
			}
		},

		async fetchReport() {
			this.reports = await YardDeliveryNoteReport.params( {
				startDate: this.startDate,
				endDate: this.endDate
			} ).get();
		},

		async fetch() {
			await this.fetchReport();
		}
	},

	watch: {
		startDate() {
			this.fetchReport();
		},

		endDate() {
			this.fetchReport();
		}
	},

	render() {
		return <VCard loading={this.$wait.is( "get delivery note reports" ) ? "link" : false}>
			<ReportHeader>
				<ReportFilters
					filters={[
						{
							key: "driver",
							value: this.driver
						},
						{
							key: "startDate",
							value: this.startDate
						},
						{
							key: "endDate",
							value: this.endDate
						}
					]}
					onSave={this.saveReportFilters}
					scopedSlots={{
						"filter.driver": props =>
							<KAutocomplete
								items={this.selectableDrivers}
								label="Driver*"
								prependIcon="person"
								vModel={props.model}
							></KAutocomplete>,

						"filter.startDate": props =>
							<KDatePicker
								textFieldProps={{
									label: "Start Date*",
									required: true
								}}
								vModel={props.model}
							></KDatePicker>,

						"filter.endDate": props =>
							<KDatePicker
								textFieldProps={{
									label: "End Date*",
									required: true
								}}
								vModel={props.model}
							></KDatePicker>
					}}
				></ReportFilters>

				<ReportChips
					cols={12}
					sm="auto"
					filters={[
						{
							name: "Driver",
							value: this.selectedDriverName
						},
						{
							name: "Start Date",
							value: this.startDate
						},
						{
							name: "End Date",
							value: this.endDate
						}
					]}
				></ReportChips>
			</ReportHeader>

			<VCardText>
				<Charts
					item={this.selectedReport}
					items={this.reports}
				></Charts>
			</VCardText>
		</VCard>;
	}
};
